import type { ReactNode } from "react";
import { Typography } from "@circle-react-uikit/Typography";

interface SidebarSubTitleProps {
  children: ReactNode;
}

export const SidebarSubTitle = ({ children }: SidebarSubTitleProps) => (
  <Typography.LabelXs weight="medium" color="text-default">
    {children}
  </Typography.LabelXs>
);
